import type { FlowSessionTurnPhaseChanged } from "@/types/events";
import { useQuery } from "@tanstack/react-query";

export const harnessTurnPhaseKey = (turnId: string | undefined) =>
  ["harnessTurnPhase", turnId] as const;

// Setup phases come from the API and the worker, so one can land after a later
// phase; the model-request phases cycle freely among themselves.
const SETUP_ORDER: Partial<
  Record<FlowSessionTurnPhaseChanged["phase"], number>
> = { provisioning: 0, starting: 1 };

/** The phase to keep when `next` arrives: never one setup has passed. */
export function nextTurnPhase(
  prev: FlowSessionTurnPhaseChanged | undefined,
  next: FlowSessionTurnPhaseChanged,
): FlowSessionTurnPhaseChanged {
  const rank = (p: FlowSessionTurnPhaseChanged) => SETUP_ORDER[p.phase] ?? 2;
  return prev && rank(next) < rank(prev) ? prev : next;
}

/** The turn's latest phase, written by the event stream; never fetched. */
export function useHarnessTurnPhase(turnId: string | undefined) {
  const { data } = useQuery<FlowSessionTurnPhaseChanged | null>({
    queryKey: harnessTurnPhaseKey(turnId),
    queryFn: () => null,
    enabled: false,
    staleTime: Infinity,
  });
  return data ?? undefined;
}
